/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UploadRouteImport } from './routes/upload'
import { Route as SearchRouteImport } from './routes/search'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as OrgRouteImport } from './routes/org'
import { Route as NotFoundRouteImport } from './routes/not-found'
import { Route as LoginRouteImport } from './routes/login'
import { Route as CoverageRouteImport } from './routes/coverage'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ContradictionsIndexRouteImport } from './routes/contradictions.index'
import { Route as ResponseQueryIdRouteImport } from './routes/response.$queryId'
import { Route as InstitutionInstitutionIdRouteImport } from './routes/institution.$institutionId'
import { Route as FindingAidEntityIdRouteImport } from './routes/finding-aid.$entityId'
import { Route as DocumentDocumentIdRouteImport } from './routes/document.$documentId'
import { Route as ContradictionsContradictionIdRouteImport } from './routes/contradictions.$contradictionId'

const UploadRoute = UploadRouteImport.update({
  id: '/upload',
  path: '/upload',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgRoute = OrgRouteImport.update({
  id: '/org',
  path: '/org',
  getParentRoute: () => rootRouteImport,
} as any)
const NotFoundRoute = NotFoundRouteImport.update({
  id: '/not-found',
  path: '/not-found',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const CoverageRoute = CoverageRouteImport.update({
  id: '/coverage',
  path: '/coverage',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ContradictionsIndexRoute = ContradictionsIndexRouteImport.update({
  id: '/contradictions/',
  path: '/contradictions/',
  getParentRoute: () => rootRouteImport,
} as any)
const ResponseQueryIdRoute = ResponseQueryIdRouteImport.update({
  id: '/response/$queryId',
  path: '/response/$queryId',
  getParentRoute: () => rootRouteImport,
} as any)
const InstitutionInstitutionIdRoute =
  InstitutionInstitutionIdRouteImport.update({
    id: '/institution/$institutionId',
    path: '/institution/$institutionId',
    getParentRoute: () => rootRouteImport,
  } as any)
const FindingAidEntityIdRoute = FindingAidEntityIdRouteImport.update({
  id: '/finding-aid/$entityId',
  path: '/finding-aid/$entityId',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentDocumentIdRoute = DocumentDocumentIdRouteImport.update({
  id: '/document/$documentId',
  path: '/document/$documentId',
  getParentRoute: () => rootRouteImport,
} as any)
const ContradictionsContradictionIdRoute =
  ContradictionsContradictionIdRouteImport.update({
    id: '/contradictions/$contradictionId',
    path: '/contradictions/$contradictionId',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/coverage': typeof CoverageRoute
  '/login': typeof LoginRoute
  '/not-found': typeof NotFoundRoute
  '/org': typeof OrgRoute
  '/profile': typeof ProfileRoute
  '/register': typeof RegisterRoute
  '/search': typeof SearchRoute
  '/upload': typeof UploadRoute
  '/contradictions/$contradictionId': typeof ContradictionsContradictionIdRoute
  '/document/$documentId': typeof DocumentDocumentIdRoute
  '/finding-aid/$entityId': typeof FindingAidEntityIdRoute
  '/institution/$institutionId': typeof InstitutionInstitutionIdRoute
  '/response/$queryId': typeof ResponseQueryIdRoute
  '/contradictions/': typeof ContradictionsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/coverage': typeof CoverageRoute
  '/login': typeof LoginRoute
  '/not-found': typeof NotFoundRoute
  '/org': typeof OrgRoute
  '/profile': typeof ProfileRoute
  '/register': typeof RegisterRoute
  '/search': typeof SearchRoute
  '/upload': typeof UploadRoute
  '/contradictions/$contradictionId': typeof ContradictionsContradictionIdRoute
  '/document/$documentId': typeof DocumentDocumentIdRoute
  '/finding-aid/$entityId': typeof FindingAidEntityIdRoute
  '/institution/$institutionId': typeof InstitutionInstitutionIdRoute
  '/response/$queryId': typeof ResponseQueryIdRoute
  '/contradictions': typeof ContradictionsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/coverage': typeof CoverageRoute
  '/login': typeof LoginRoute
  '/not-found': typeof NotFoundRoute
  '/org': typeof OrgRoute
  '/profile': typeof ProfileRoute
  '/register': typeof RegisterRoute
  '/search': typeof SearchRoute
  '/upload': typeof UploadRoute
  '/contradictions/$contradictionId': typeof ContradictionsContradictionIdRoute
  '/document/$documentId': typeof DocumentDocumentIdRoute
  '/finding-aid/$entityId': typeof FindingAidEntityIdRoute
  '/institution/$institutionId': typeof InstitutionInstitutionIdRoute
  '/response/$queryId': typeof ResponseQueryIdRoute
  '/contradictions/': typeof ContradictionsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/coverage'
    | '/login'
    | '/not-found'
    | '/org'
    | '/profile'
    | '/register'
    | '/search'
    | '/upload'
    | '/contradictions/$contradictionId'
    | '/document/$documentId'
    | '/finding-aid/$entityId'
    | '/institution/$institutionId'
    | '/response/$queryId'
    | '/contradictions/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/coverage'
    | '/login'
    | '/not-found'
    | '/org'
    | '/profile'
    | '/register'
    | '/search'
    | '/upload'
    | '/contradictions/$contradictionId'
    | '/document/$documentId'
    | '/finding-aid/$entityId'
    | '/institution/$institutionId'
    | '/response/$queryId'
    | '/contradictions'
  id:
    | '__root__'
    | '/'
    | '/coverage'
    | '/login'
    | '/not-found'
    | '/org'
    | '/profile'
    | '/register'
    | '/search'
    | '/upload'
    | '/contradictions/$contradictionId'
    | '/document/$documentId'
    | '/finding-aid/$entityId'
    | '/institution/$institutionId'
    | '/response/$queryId'
    | '/contradictions/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CoverageRoute: typeof CoverageRoute
  LoginRoute: typeof LoginRoute
  NotFoundRoute: typeof NotFoundRoute
  OrgRoute: typeof OrgRoute
  ProfileRoute: typeof ProfileRoute
  RegisterRoute: typeof RegisterRoute
  SearchRoute: typeof SearchRoute
  UploadRoute: typeof UploadRoute
  ContradictionsContradictionIdRoute: typeof ContradictionsContradictionIdRoute
  DocumentDocumentIdRoute: typeof DocumentDocumentIdRoute
  FindingAidEntityIdRoute: typeof FindingAidEntityIdRoute
  InstitutionInstitutionIdRoute: typeof InstitutionInstitutionIdRoute
  ResponseQueryIdRoute: typeof ResponseQueryIdRoute
  ContradictionsIndexRoute: typeof ContradictionsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/upload': {
      id: '/upload'
      path: '/upload'
      fullPath: '/upload'
      preLoaderRoute: typeof UploadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/org': {
      id: '/org'
      path: '/org'
      fullPath: '/org'
      preLoaderRoute: typeof OrgRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/not-found': {
      id: '/not-found'
      path: '/not-found'
      fullPath: '/not-found'
      preLoaderRoute: typeof NotFoundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/coverage': {
      id: '/coverage'
      path: '/coverage'
      fullPath: '/coverage'
      preLoaderRoute: typeof CoverageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contradictions/': {
      id: '/contradictions/'
      path: '/contradictions'
      fullPath: '/contradictions/'
      preLoaderRoute: typeof ContradictionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/response/$queryId': {
      id: '/response/$queryId'
      path: '/response/$queryId'
      fullPath: '/response/$queryId'
      preLoaderRoute: typeof ResponseQueryIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/institution/$institutionId': {
      id: '/institution/$institutionId'
      path: '/institution/$institutionId'
      fullPath: '/institution/$institutionId'
      preLoaderRoute: typeof InstitutionInstitutionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finding-aid/$entityId': {
      id: '/finding-aid/$entityId'
      path: '/finding-aid/$entityId'
      fullPath: '/finding-aid/$entityId'
      preLoaderRoute: typeof FindingAidEntityIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/document/$documentId': {
      id: '/document/$documentId'
      path: '/document/$documentId'
      fullPath: '/document/$documentId'
      preLoaderRoute: typeof DocumentDocumentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contradictions/$contradictionId': {
      id: '/contradictions/$contradictionId'
      path: '/contradictions/$contradictionId'
      fullPath: '/contradictions/$contradictionId'
      preLoaderRoute: typeof ContradictionsContradictionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CoverageRoute: CoverageRoute,
  LoginRoute: LoginRoute,
  NotFoundRoute: NotFoundRoute,
  OrgRoute: OrgRoute,
  ProfileRoute: ProfileRoute,
  RegisterRoute: RegisterRoute,
  SearchRoute: SearchRoute,
  UploadRoute: UploadRoute,
  ContradictionsContradictionIdRoute: ContradictionsContradictionIdRoute,
  DocumentDocumentIdRoute: DocumentDocumentIdRoute,
  FindingAidEntityIdRoute: FindingAidEntityIdRoute,
  InstitutionInstitutionIdRoute: InstitutionInstitutionIdRoute,
  ResponseQueryIdRoute: ResponseQueryIdRoute,
  ContradictionsIndexRoute: ContradictionsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
